function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { List, Text, Flex, Button } from '@leverege/ui-elements';
export default function ValueRangeListRenderer(props) {
  const {
    item,
    onEvent,
    onParentChange,
    ...rest
  } = props;
  const onDelete = e => {
    onEvent({
      type: 'child.remove',
      item,
      data: 'removeValueRange'
    });
  };
  return /*#__PURE__*/React.createElement(List.Item, _extends({
    item: item
  }, rest), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowM",
    justify: "space-between",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "listItemSubtitle"
  }, item?.name), /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    eventData: item,
    onClick: onDelete,
    icon: "fa fa-trash"
  })));
}